import React, { Fragment } from 'react';
import Select from 'react-select';
import { defaultTo, path } from 'ramda';
import { withFormik } from 'formik';

import { apiUpdateProfile } from '../../../api/user';
import { handleError, handleSuccess } from '../../../util/forms';
import { routes } from '../../../routes';

import Checkbox from '../../../components/Forms/Checkbox';
import EditField from '../../../components/Forms/EditField';

const AFCPESettings = ({
  user,
  handleBlur,
  handleChange,
  handleSubmit,
  isValid,
  isSubmitting,
  setFieldValue,
  values,
}) => {
  const isMember = path(['membership', 'valid'], user);
  const options = [
    { value: 'nothing', label: 'Nothing' },
    { value: 'mentor', label: 'Mentor' },
    { value: 'mentee', label: 'Mentee' },
    { value: 'both', label: 'Both' },
  ];
  return (
    <div>
      {isMember && !user.militarySpouse && (
        <Fragment>
          <h2>MentorConnect</h2>
          <div className="form-group row">
            <div className="col-md-10">
              If you are interested in mentorship, or would like to offer professional guidance by serving as a mentor,
              please indicate your interest below
            </div>
          </div>
          <EditField
            as={Select}
            bare
            simpleValue
            name="mentorConnect"
            label="MentorConnect status"
            onChange={(value) => setFieldValue('mentorConnect', value)}
            options={options}
            value={values.mentorConnect}
          />

          {values.mentorConnect && values.mentorConnect != 'nothing' && (
            <p className="font-weight-bold">
              In order to finish signing up for mentorship, please fill out the form{' '}
              <a href={routes.wordPress.mentorConnectForm} target="_blank">
                here
              </a>
            </p>
          )}

          <hr />
        </Fragment>
      )}

      {user.militarySpouse && (
        <Fragment>
          <h2>Mentorship</h2>
          <div className="form-group row">
            <div className="col-md-10">
              If you are interested in mentorship, or would like to offer professional guidance by serving as a mentor,
              please indicate your interest below
            </div>
          </div>
          <EditField
            as={Select}
            bare
            simpleValue
            name="mspMentorship"
            label="Mentorship status"
            onChange={(value) => setFieldValue('mspMentorship', value)}
            options={options}
            value={values.mspMentorship}
          />

          {values.mspMentorship && values.mspMentorship != 'nothing' && (
            <p className="font-weight-bold">
              In order to finish signing up for mentorship, please fill out the form{' '}
              <a href={routes.wordPress.mentorshipForm} target="_blank">
                here
              </a>
            </p>
          )}

          <hr />
        </Fragment>
      )}

      <h2>Media Resource</h2>
      <div className="form-group row">
        <div className="col-md-10">
          Sage Financial Solutions is occasionally contacted by the media looking for a professional source. Are you interested in being a
          media source?
        </div>
      </div>
      <Checkbox
        name="mediaResource"
        label="Yes, I am interested in being a resource for media inquiries."
        checked={values.mediaResource}
        onBlur={handleBlur}
        onChange={handleChange}
      />

      <hr />

      {isMember && (
        <Fragment>
          <h2>Membership Journal</h2>
          <Checkbox
            name="physicalJournal"
            label="Yes, I would like to receive a hard copy of the journal."
            checked={values.physicalJournal}
            onBlur={handleBlur}
            onChange={handleChange}
          />

          <hr />
        </Fragment>
      )}

      <div className="form-group row row mb-0">
        <div className="col-md-6 offset-md-4 text-right">
          <button type="submit" className="btn btn-primary" disabled={!isValid || isSubmitting} onClick={handleSubmit}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiUpdateProfile(payload)
      .then(({ data }) => props.updateUser(data))
      .then(() => handleSuccess(formProps))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ user }) => ({
    mentorConnect: defaultTo('', user.mentorConnect),
    mspMentorship: defaultTo('', user.mspMentorship),
    mediaResource: user.mediaResource,
    physicalJournal: user.physicalJournal,
  }),
  isInitialValid: true,
  validateOnChange: true,
})(AFCPESettings);
